import moment from 'moment';
import '../httpservices/core/ajax.httpservice.core';

//see layout.entry.js to see it used
//ie: new TimeOutService().Start();
//then watch the result property in a watcher so the timer will update

export default class TimeOutService {

    constructor() {
        this.config = {

            //how many minutes until you show the idle dialog?
            showIdleWarningInSeconds: $('#IdleTimeoutWarningInSeconds').val(),

            //how many minutes until you log a user out
            logUserOutInSeconds: $('#IdleTimeoutLogoutInSeconds').val()
        };

        //holds the timer object (set interval id)
        this.timerObject = null;

        //holds the current last action date time. (ie: last time the user made an action)
        this._lastActionDateTime = null;
        this.dateUserWillBeForcedOut = null;

        //holds the status and result
        this.result = {
            status: 'UserIsActive', //|| UserIsIdle (show dialog or something) || LogUserOut
            secondsUntilLogOut: null
        };
    }

    get lastActionDateTime() {
        return this._lastActionDateTime;
    }

    set lastActionDateTime(value) {
        this._lastActionDateTime = value;
        this.dateUserWillBeForcedOut = moment(value).add(this.config.logUserOutInSeconds, 's').toDate();
    }

    Start() {

        //set the last activity date
        this.lastActionDateTime = new Date();

        //using ajax send so we can register multiple event handlers. Ajax Setup is 1 handler globally
        $(document).ajaxSend((ev, jqhr, settings) => this.ResetTimer(false));

        //go run the timer object to check every second
        this.timerObject = setInterval(() => this.checkStatus.bind(this)(), 1000);

        //return the instance so we can use this call in 1 line
        return this;
    }

    ResetTimer(extendSessionTimeoutAjaxCall) {

        this.lastActionDateTime = new Date();

        if (extendSessionTimeoutAjaxCall == null || extendSessionTimeoutAjaxCall) {

            //go make an ajax call so we set the session timeout to x amount of minutes later
            $.get('RedirectBroker/RefreshSession');
        }
    }

    checkStatus() {

        let now = new Date().getTime();

        let differenceInSeconds = ((now - this.lastActionDateTime.getTime()) / 1000);

        if (differenceInSeconds < this.config.showIdleWarningInSeconds) {
            this.result.status = 'UserIsActive';
        } else if (differenceInSeconds >= this.config.logUserOutInSeconds) {

            //stop the timer now. If they are on a low bandwidth and we still have the timer going as we boot them off then it will end up in a loop with requests being queued and cancelled repeatedly until it can't take anymore
            clearInterval(this.timerObject);

            this.result.status = 'LogUserOut';
        }
        else if (differenceInSeconds >= this.config.showIdleWarningInSeconds) {
            this.result.status = 'UserIsIdle';
        }

        //set how many seconds until log out
        this.result.secondsUntilLogOut = Math.round(((this.dateUserWillBeForcedOut.getTime() - now) / 1000));

        //for debugging
        //console.log('Seconds Until Last Action: ' + differenceInSeconds);
        //console.log('Seconds Until Log Out: ' + this.result.secondsUntilLogOut);
        //console.log('Status: ' + this.result.status);
    }

}
